import {
  forwardRef, useCallback, useImperativeHandle, useRef,
} from 'react';
import { DropDownMenuItem } from '../DropdownMenu';
import SharedAutoComplete, { SharedAutoCompleteRef } from './SharedAutoComplete';

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface SharedAutoCompleteCellRenderProps<T=any> {
  value?: any
  stopEditing: () => void
  options: DropDownMenuItem<T>[]
  onSelect: (rowIdentifier: any, selected: T) => void
  rowIdentifier: any
  onTextInput?: (rowIdentifier: any, value: string) => void
  onBlur?: () => void
  onBlurSetTextAsSelected?: boolean
  popperZIndex?: number
}

export interface SharedAutoCompleteCellRenderRef {
  getValue: () => any
}

export default forwardRef<SharedAutoCompleteCellRenderRef, SharedAutoCompleteCellRenderProps>((props, ref) => {
  const { onBlurSetTextAsSelected = true } = props;
  const sharedRef = useRef<SharedAutoCompleteRef>(null);

  const handleSelect = useCallback((value: any) => {
    props.onSelect(props.rowIdentifier, value);
    if (onBlurSetTextAsSelected) return;
    props.stopEditing();
  }, [props, onBlurSetTextAsSelected]);

  const handleTextInput = useCallback((value: string) => {
    if (props.onTextInput) {
      props.onTextInput(props.rowIdentifier, value);
    }
  }, [props]);

  useImperativeHandle(ref, () => ({
    getValue() {
      return sharedRef.current?.getValue();
    },
  }));

  return (
    <SharedAutoComplete
      ref={sharedRef}
      value={props.value}
      options={props.options}
      onSelect={handleSelect}
      onTextInput={handleTextInput}
      onBlur={props.onBlur}
      onBlurSetTextAsSelected={onBlurSetTextAsSelected}
      popperZIndex={props.popperZIndex}
    />
  );
});
